import React from "react";
import { Skeleton } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";

const TrebbleSkeleton = ({useEditorTheme, ...restProps}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({useEditorTheme});

  return (
    <ConfigProvider theme={themeConfig}>
      <Skeleton {...restProps} />
    </ConfigProvider>
  );
};

// Create Avatar component that also uses the theme
const TrebbleSkeletonAvatar = ({useEditorTheme, ...restProps}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({useEditorTheme});

  return (
    <ConfigProvider theme={themeConfig}>
      <Skeleton.Avatar {...restProps} />
    </ConfigProvider>
  );
};

// Attach Avatar as a property of TrebbleSkeleton
TrebbleSkeleton.Avatar = TrebbleSkeletonAvatar;

TrebbleSkeleton.propTypes = {
  useEditorTheme: PropTypes.bool
}

TrebbleSkeletonAvatar.propTypes = {
  useEditorTheme: PropTypes.bool
}

export default TrebbleSkeleton;
